import React, { useState, useEffect, useRef } from "react";
import leftArrowSvg from "../../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../../Assets/rightArrowSvg.svg";
import mobileQrFeedBack from "../../../Assets/mobileQrFeedBack.png";
import dummyBussinesLogo from "../../../Assets/dummyBussinesLogo.png";

import brand_logo from "../../../Assets/brand_logo.png";
import { Eye, X, SquareUserRound } from "lucide-react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Modal from "react-bootstrap/Modal";

import {
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import QRCodeStyling from "qr-code-styling";
import { useSelector } from "react-redux";
import Temp1 from "../Templates/temp1";
import Temp2 from "../Templates/temp2";
import Temp3 from "../Templates/temp3";
import "../../CSS/NewOnboading/Step8.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
export default function Step8Page({ onBack, onNext }) {
  const navigate = useNavigate();
  const templateData = useSelector((state) => state.step.templateData);
  const [activeTemplateId, setActiveTemplateId] = useState("1");

  const [logo, setLogo] = useState(dummyBussinesLogo);
  const [bussinesText, setbussinesText] = useState("Adidas Pvt. Ltd.");
  const [tagLine, settagLine] = useState("Best Shop in Town");
  const [showModal, setShowModal] = useState(false);
  const [headingText, setHeadingText] = useState("Your Feedback Matters!");
  const [BusinessText, setBusinessText] = useState("Business Name");
  const [tagLineText, settagLineText] = useState("Tagline");
  const [subheadingText, setSubheadingText] = useState(
    "Enjoyed your experience? Share your reviews on your favorite platform below!",
  );
  const [ctaHeading, setCtaHeading] = useState("If you had a bad experience!");
  const [ctaText, setCtaText] = useState("Contact Manager");

  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };

  // State for QR code styling
  const [selectedPattern, setSelectedPattern] = useState("");
  const [selectedFrame, setSelectedFrame] = useState("frameBox1"); // Default to 'No Frame'

  // QR Code refs
  const qrCodeRef = useRef(null);
  const modalQrCodeRef = useRef(null);
  const qrInstance = useRef(null);

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [textColor, setTextColor] = useState("#333");
  const [bgColor, setBgColor] = useState("#fff");
  const [ctaHeading1, setCtaHeading1] = useState("Good Experience");
  const [ctaText1, setCtaText1] = useState("Needs Improvement");
  const rightFileInputRef = useRef(null);

  const TEMPLATES = [
    {
      id: "6",
      name: "Template 1",
      component: Temp1,
    },
    {
      id: "2",
      name: "Template 2",
      component: Temp2,
    },
    {
      id: "1",
      name: "Template 3",
      component: Temp3,
    },
  ];
  // Template data for display (from Redux if available, otherwise defaults)
  const [currentTemplateData, setCurrentTemplateData] = useState({
    heading: "Your Feedback Matters!",
    subheading:
      "Enjoyed your experience? Share your reviews on your favorite platform below!",
    bottomHeading: "If you had a bad experience!",
    showSocialIcons: true,
    footerText: "Team WOW Reviews",
    cta_text: "Contact Manager",
    cta_heading: "If you had a bad experience!",
  });

  // Style configuration for the template
  const [styles, setStyles] = useState({
    backgroundColor: "#ffffff",
    textColor: "#000000",
    ctaColor: "#ff5722",
  });

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "8");
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          if (final_data.onboarding_data.length > 0) {
            setbusinessTypes(final_data.onboarding_data[0]);
            setbussinesText(final_data.onboarding_data[0].business_name);
            settagLine(final_data.onboarding_data[0].business_tagline);
            setSelectedFrame(final_data.onboarding_data[0].frame_name);
            setSelectedPattern(final_data.onboarding_data[0].parttan_name);
            setLogo(
              final_data.review_linkss_link +
                final_data.onboarding_data[0].website_logo,
            );
            if (
              final_data.onboarding_data[0].heading_text !== "" &&
              final_data.onboarding_data[0].heading_text !== null
            ) {
              setHeadingText(final_data.onboarding_data[0].heading_text);
            }
            if (
              final_data.onboarding_data[0].subheading_text !== "" &&
              final_data.onboarding_data[0].subheading_text !== null
            ) {
              setSubheadingText(final_data.onboarding_data[0].subheading_text);
            }
            if (
              final_data.onboarding_data[0].cta_heading !== "" &&
              final_data.onboarding_data[0].cta_heading !== null
            ) {
              setCtaHeading(final_data.onboarding_data[0].cta_heading);
            }
            if (
              final_data.onboarding_data[0].cta_text !== "" &&
              final_data.onboarding_data[0].cta_text !== null
            ) {
              setCtaText(final_data.onboarding_data[0].cta_text);
            }
            if (
              final_data.onboarding_data[0].application_color !== "" &&
              final_data.onboarding_data[0].application_color !== null
            ) {
              setStyles({
                backgroundColor:
                  final_data.onboarding_data[0].application_color,
                textColor: final_data.onboarding_data[0].application_text_color,
                ctaColor: final_data.onboarding_data[0].application_color,
              });
            }
            if (
              final_data.onboarding_data[0].application_text_color !== "" &&
              final_data.onboarding_data[0].application_text_color !== null
            ) {
              setTextColor(
                final_data.onboarding_data[0].application_text_color,
              );
            }
            if (
              final_data.onboarding_data[0].application_color !== "" &&
              final_data.onboarding_data[0].application_color !== null
            ) {
              setBgColor(final_data.onboarding_data[0].application_color);
            }
            setActiveTemplateId(final_data.onboarding_data[0].theme_other_id);
          }
          setbusinessImage(final_data.review_linkss_link);

          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  // Initialize with redux data if available
  useEffect(() => {
    master_data_get();

    // If we have templateData from Redux, use it
    if (templateData) {
      console.log("Template data from Redux:", templateData);

      // Set the logo from templateData if available
      if (templateData.logo) {
        //  setLogo(templateData.logo);
      }

      // Set the styles from templateData
      if (templateData.styles) {
        setStyles(templateData.styles);
      }

      // Set the current template data
      if (templateData.templateInfo) {
        setCurrentTemplateData(templateData.templateInfo);
      }
    }
  }, [templateData]);

  const handleNext = async () => {
    const hasErrors = false;
    if (!hasErrors) {
      setIsLoading(true);
      let fd_from = new FormData();
      fd_from.append("flag", "8");
      fd_from.append("skip_or_not", "1");
      await server_post_data(insert_update_business_data_onboarding, fd_from)
        .then((Response) => {
          setIsLoading(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            const chargebeeCheckoutUrl =
              final_data.checkout_url || final_data.chargebee_checkout_url;
            if (chargebeeCheckoutUrl === "skip") {
              const id = uuidv4();
              const cus_id = uuidv4();
              const sub_id = uuidv4();

              navigate(
                `/sucees_page?id=${id}&cus_id=${cus_id}&sub_id=${sub_id}`,
              );
            } else {
              window.location.href = chargebeeCheckoutUrl;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  // Effect to create and update QR code when styling changes
  useEffect(() => {
    const createQRCode = (containerRef) => {
      if (!containerRef.current) return;

      // Clear previous content
      containerRef.current.innerHTML = "";
      console.log("ssss", selectedPattern);
      // Create new QR code instance
      const currentDotStyle = selectedPattern;
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        shape: selectedFrame === "frameBox circularFrame" ? "circle" : "square",
        data: "https://www.wowreviews.co",
        // image: logo && !isLogoRemoved ? logo : undefined,
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 10,
        },
        dotsOptions: {
          type: currentDotStyle,
          color: "#000",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          color: "#000",
        },
        backgroundOptions: {
          color: "#fff",
        },
      });

      // Append to container
      qrCode.append(containerRef.current);

      // Style the canvas and its parent container
      setTimeout(() => {
        const canvas = containerRef.current.querySelector("canvas");
        if (canvas) {
          canvas.style.width = "100%";
          canvas.style.height = "100%";

          // Apply styling to the canvas
          if (selectedFrame === "frameBox circularFrame") {
            canvas.style.borderRadius = "50%";
            canvas.style.clipPath = "circle(50% at center)";
          } else if (selectedFrame === "frameBox") {
            canvas.style.borderRadius = "12px";
            canvas.style.clipPath = "none";
          } else {
            canvas.style.borderRadius = "0";
            canvas.style.clipPath = "none";
          }
        }
      }, 100);

      return qrCode;
    };

    // Create QR code in main view
    if (qrCodeRef.current) {
      qrInstance.current = createQRCode(qrCodeRef);
    }

    // Create QR code in modal if modal is open
    if (showModal && modalQrCodeRef.current) {
      createQRCode(modalQrCodeRef);
    }
  }, [selectedPattern, selectedFrame, logo, showModal]);

  const renderActiveTemplate = () => {
    // Get the template from our templates object
    console.log(activeTemplateId);
    const activeTemplate = TEMPLATES.find(
      (template) => template.id === activeTemplateId,
    );

    if (!activeTemplate) {
      console.error(`Template with ID ${activeTemplateId} not found`);
      return null;
    }

    const TemplateComponent = activeTemplate.component;

    let finalCtaHeading = ctaHeading;
    let finalCtatext = ctaText;

    if (activeTemplateId === "2" || activeTemplateId === "3") {
      finalCtaHeading = ctaHeading1;
      finalCtatext = ctaText1;
    } else {
      finalCtaHeading = ctaHeading;
      finalCtatext = ctaText;
    }

    return (
      <TemplateComponent
        logo={logo}
        brand_logo={brand_logo}
        headingText={headingText}
        subheadingText={subheadingText}
        businessTypes2={businessTypes2}
        businessImage2={businessImage2}
        ctaHeading={finalCtaHeading}
        ctaText={finalCtatext}
        styles={styles}
        SquareUserRound={SquareUserRound}
        rightFileInputRef={rightFileInputRef}
      />
    );
  };

  // Custom styles for the frames in the QR display
  const getFrameStyles = () => ({
    width: "140px",
    height: "140px",
    borderRadius:
      selectedFrame === "frameBox circularFrame"
        ? "50%"
        : selectedFrame === "frameBox"
          ? "12px"
          : "0",
    overflow: "hidden",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const swiperRef = useRef(null);
  const sliderSettings = {
    dots: true,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: true,
  };

  return (
    <div
      className="tell_aboutSection margin_none step_8_container"
      style={{ backgroundColor: "#F0EFEA" }}
    >
      <div
        className="bussiness_typeCard margin_none pading_clss"
        style={{ position: "relative" }}
      >
        <div className="step7Div step_8_Update_design">
          <div className="height_ovr_flow_clss_step8">
            {" "}
            <div className="mb-3" style={{ marginTop: "-24px" }}>
              <h1>Your QR Experience Is Ready to Launch!</h1>
              <div className="scnPageLvl">
                {" "}
                <label className="width_clss_abt">
                  Your scan page, QR display, and branding are set. Go live and
                  start capturing feedback where it counts.
                </label>
              </div>
            </div>
            <div className="row justify-content-center gap-2">
              {!isMobile && (
                <>
                  {renderActiveTemplate()}
                  <div className="col-lg-4 col-md-5 col-sm-6 ">
                    <div className="qrScreenMobile">
                      <div className="logoSection">
                        <div className="logoCircle">
                          <img
                            src={logo || dummyBussinesLogo}
                            className="dummyBussinesLogo"
                            title="Bussiness Logo"
                            alt="Logo"
                          />
                        </div>
                        <div className="businessInfo">
                          <h2>{bussinesText}</h2>
                          <p>{tagLine}</p>
                        </div>
                      </div>
                      <div
                        className="feedbackSection"
                        style={{ backgroundColor: bgColor }}
                      >
                        <p style={{ color: textColor }}>
                          Please Provide your valuable
                        </p>
                        <h1 style={{ color: textColor }}>Feedback</h1>
                      </div>
                      <div className="qrCodeContainer">
                        {selectedPattern && selectedPattern !== "" && (
                          <div
                            className={selectedFrame}
                            style={{
                              ...getFrameStyles(),
                              clipPath:
                                selectedFrame === "frameBox circularFrame"
                                  ? "circle(50% at center)"
                                  : "none",
                            }}
                          >
                            <div
                              ref={qrCodeRef}
                              style={{
                                width: "120px",
                                height: "120px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                borderRadius:
                                  selectedFrame === "frameBox circularFrame"
                                    ? "50%"
                                    : selectedFrame === "frameBox"
                                      ? "12px"
                                      : "0",
                                clipPath:
                                  selectedFrame === "frameBox circularFrame"
                                    ? "circle(50% at center)"
                                    : "none",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="social-icons">
                        {businessTypes2.map((item, index) => {
                          if (index < 4) {
                            return (
                              <img
                                key={index}
                                src={businessImage2 + item.review_logo}
                                alt={item.review_name}
                                title={item.review_name}
                              />
                            );
                          }
                          return null;
                        })}
                      </div>

                      <div className="preview-footer">
                        Powered by Your <span>Wowreviews</span>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {isMobile && (
                <>
                  <Slider {...sliderSettings} className="template-swiper">
                    <div>
                      <div className="templateContainer">
                        {renderActiveTemplate()}
                      </div>
                    </div>

                    <div>
                      <div className="col-lg-4 col-md-5 col-sm-6 qr_screen_8_step ">
                        <div className="qrScreenMobile">
                          <div className="logoSection">
                            <div className="logoCircle">
                              <img
                                src={logo || dummyBussinesLogo}
                                className="dummyBussinesLogo"
                                title="Bussiness Logo"
                                alt="Logo"
                              />
                            </div>
                            <div className="businessInfo">
                              <h2>{bussinesText}</h2>
                              <p>{tagLine}</p>
                            </div>
                          </div>

                          <div
                            className="feedbackSection"
                            style={{ backgroundColor: bgColor }}
                          >
                            <p style={{ color: textColor }}>
                              Please Provide your valuable
                            </p>
                            <h1 style={{ color: textColor }}>Feedback</h1>
                          </div>

                          <div className="qrCodeContainer">
                            {selectedPattern && selectedPattern !== "" && (
                              <div
                                className={selectedFrame}
                                style={{
                                  ...getFrameStyles(),
                                  clipPath:
                                    selectedFrame === "frameBox circularFrame"
                                      ? "circle(50% at center)"
                                      : "none",
                                }}
                              >
                                <div
                                  ref={qrCodeRef}
                                  style={{
                                    width: "120px",
                                    height: "120px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    borderRadius:
                                      selectedFrame === "frameBox circularFrame"
                                        ? "50%"
                                        : selectedFrame === "frameBox"
                                          ? "12px"
                                          : "0",
                                    clipPath:
                                      selectedFrame === "frameBox circularFrame"
                                        ? "circle(50% at center)"
                                        : "none",
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="social-icons">
                            {businessTypes2.map((item, index) =>
                              index < 4 ? (
                                <img
                                  key={index}
                                  src={businessImage2 + item.review_logo}
                                  alt={item.review_name}
                                  title={item.review_name}
                                />
                              ) : null,
                            )}
                          </div>

                          <div className="preview-footer">
                            Powered by Your <span>Wowreviews</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </>
              )}
            </div>
          </div>
          <div className="pre_next_bttn_div">
            <button className="prevBtn" onClick={onBack}>
              <img
                src={leftArrowSvg}
                alt="left"
                title="left"
                className="leftArrowSvg"
              />
              Back
            </button>
            <button className="nextBtn" onClick={handleNext}>
              <span className="full-text">Start Free 14 Days Trial</span>
              <span className="short-text">Start Trial</span>
              <img
                src={rightArrowSvg}
                alt="right"
                title="right"
                className="right_arrw_svg"
              />
            </button>
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={handlePreviewMobile}
        centered
        backdrop="static"
      >
        <Modal.Body style={{ position: "relative" }}>
          <X
            size={25}
            onClick={handlePreviewMobile}
            className="close_model_div"
          />

          <div className="step7Div">
            <div className="preview-panel">
              <div className="mobile-frame">
                <div
                  className="mobile-content"
                  style={{
                    background: "#ffffff",
                    color: "#000000",
                  }}
                >
                  {/* Logo Preview */}
                  <div className="logo-preview">
                    {templateData && templateData.logo ? (
                      <img
                        src={templateData.logo}
                        alt="Brand Logo"
                        className="preview-logo"
                      />
                    ) : logo ? (
                      <img
                        src={logo}
                        alt="Brand Logo"
                        className="preview-logo"
                      />
                    ) : (
                      <div className="logo-placeholder">
                        <img
                          src={brand_logo}
                          className="brand_logo"
                          alt="brand_logo"
                        />
                      </div>
                    )}
                  </div>

                  {/* Heading from Template */}
                  <div className="preview-heading" style={{ color: "#000000" }}>
                    {currentTemplateData.heading}
                  </div>

                  {/* Subheading from Template */}
                  <div
                    className="preview-subheading"
                    style={{ color: "#000000" }}
                  >
                    {currentTemplateData.subheading}
                  </div>

                  {/* Social Icons */}
                  <div className="social-icons">
                    {businessTypes2.map((item, index) => {
                      if (index < 4) {
                        return (
                          <img
                            key={index}
                            src={businessImage2 + item.review_logo}
                            alt={item.review_name}
                            title={item.review_name}
                          />
                        );
                      }
                      return null;
                    })}
                  </div>

                  {/* CTA Preview */}
                  <div className="preview-cta-section">
                    <div
                      className="preview-cta-heading"
                      style={{ color: "#000000" }}
                    >
                      {currentTemplateData.bottomHeading}
                    </div>

                    {/* Additional text if available */}
                    {currentTemplateData.additionalText && (
                      <div
                        className="preview-additional-text"
                        style={{ color: "#000000" }}
                      >
                        {currentTemplateData.additionalText}
                      </div>
                    )}

                    <button
                      className="preview-cta-button"
                      style={{
                        backgroundColor: styles.ctaColor || "#ff5722",
                        color: "#fff",
                      }}
                    >
                      <SquareUserRound className="cta_icnn" />
                      {currentTemplateData.cta_text || "Contact Manager"}
                    </button>
                  </div>

                  {/* Footer */}
                  <div className="preview-footer">
                    Powered by Your <span>Wowreviews</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
